module.exports = new __parcel__URL__("Frame-6.17d4bfe5.svg").toString();